var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.25C7.82209 10.6806 8.23302 11.0369 8.70491 11.2947C9.17681 11.5525 9.69863 11.7058 10.235 11.7442C10.7713 11.7826 11.3097 11.7052 11.8135 11.5173C12.3173 11.3294 12.7748 11.0353 13.155 10.655L15.405 8.40497C16.0881 7.69772 16.4661 6.75046 16.4575 5.76722C16.449 4.78398 16.0546 3.84343 15.3593 3.14815C14.664 2.45287 13.7235 2.05849 12.7403 2.04995C11.757 2.0414 10.8098 2.41938 10.1025 3.10247L8.8125 4.38497",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 8.74992C10.1776 8.31933 9.76664 7.96304 9.29475 7.70522C8.82285 7.4474 8.30103 7.29409 7.76467 7.25567C7.22832 7.21726 6.68997 7.29465 6.18615 7.48259C5.68233 7.67053 5.22483 7.96462 4.84466 8.34492L2.59466 10.5949C1.91157 11.3022 1.53359 12.2494 1.54213 13.2327C1.55068 14.2159 1.94506 15.1565 2.64034 15.8517C3.33562 16.547 4.27617 16.9414 5.25941 16.95C6.24264 16.9585 7.1899 16.5805 7.89716 15.8974L9.17966 14.6149",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteLink);
export default __webpack_public_path__ + "static/media/Website_Link.2fe7d35c888386972382ea77ccf7c7a6.svg";
export { ForwardRef as ReactComponent };